import { Banner, Button } from "@NP-Webber/crm-kit/dist/next/index.js";
import type { ImportType } from "../../../api/aiDataEntryApi";
import { openDataEntryAgent, useCanOpenDataEntry } from "./dataEntryLauncher";
import "./dataEntryRecommendation.css";

const DEFAULT_TEXT =
  "הסוכן קורא את הקובץ כמו שהוא, מזהה כל שורה, משייך ללקוחות ולספקים ומזהה כפילויות ורשומות קיימות — אתם רק מאשרים, וכל רישום ניתן לביטול.";

export type DataEntryRecommendationProps = {
  /** the kind preselected in the agent when the file itself does not say (e.g. "customers", "incomes", "bank") */
  importType?: ImportType;
  /** the explanation after the bold line (a default text is used) */
  text?: string;
  /** closes the import wizard before the agent opens */
  onLeave?: () => void;
};

/**
 * «מומלץ לעבוד עם המנגנון החדש — הזנה חכמה» (ADR-0037, Turbo's DataEntryRecommendation): shown on the
 * first step of the import wizards whose data the data-entry agent can write. The button closes the
 * wizard (onLeave) and opens the agent. Renders nothing where the agent cannot be opened (no
 * ai.data_entry.use / not in the user's menu — see dataEntryLauncher); the backend checks every call.
 */
export function DataEntryRecommendation({ importType = "auto", text = DEFAULT_TEXT, onLeave }: DataEntryRecommendationProps) {
  const can = useCanOpenDataEntry();
  if (!can) return null;
  const open = () => {
    onLeave?.();
    openDataEntryAgent({ importType });
  };
  return (
    <div className="de-reco">
      <Banner
        tone="info"
        icon="sparkle"
        action={
          <Button size="sm" variant="primary" icon="sparkle" onClick={open}>
            פתיחת ההזנה החכמה
          </Button>
        }
      >
        <b>מומלץ לעבוד עם המנגנון החדש — הזנה חכמה.</b> {text}
      </Banner>
    </div>
  );
}

export default DataEntryRecommendation;
